import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { hashHistory } from 'react-router';

import WixSDK from 'shared/utils/wix-sdk';
import deviceTypes from 'shared/constants/device-types';

import { CHANNEL_LAYOUT_VALUES } from 'wix-vod-shared/src/app-settings/constants/channel-layout-values';
import AppSettingsLoader from 'widget/data-components/app-settings';

const layoutRoutes = {
  [CHANNEL_LAYOUT_VALUES.STRIP]: '/desktop/strip',
  [CHANNEL_LAYOUT_VALUES.CLASSIC]: '/desktop/classic',
  [CHANNEL_LAYOUT_VALUES.COMPACT]: '/desktop/compact',
};

@connect(state => ({
  appSettings: state.appSettings,
}))
export default class LayoutSwitcher extends React.Component {

  static propTypes = {
    children: PropTypes.element,
    appSettings: PropTypes.object,
  };

  componentWillMount() {
    const deviceType = WixSDK.Utils.getDeviceType();
    const { pathname = '/' } = hashHistory.getCurrentLocation();

    if (pathname !== '/') {
      return;
    }

    if (deviceType === deviceTypes.MOBILE) {
      hashHistory.replace('/mobile');
    } else {
      hashHistory.replace('/desktop');
    }
  }

  componentWillUpdate(nextProps) {
    const currentLayout = this._getLayout(this.props);
    const nextLayout = this._getLayout(nextProps);
    const deviceType = WixSDK.Utils.getDeviceType();

    if (_.has(layoutRoutes, nextLayout) && nextLayout !== currentLayout) {
      if (deviceType === deviceTypes.MOBILE) {
        hashHistory.push('mobile/default');
      } else {
        hashHistory.push(layoutRoutes[nextLayout]);
      }
    }
  }

  _getLayout(props) {
    return _.get(props, 'appSettings.numbers.channelLayout');
  }

  render() {
    const { children, appSettings } = this.props;

    return (
      <AppSettingsLoader>
        {!_.isEmpty(appSettings) && children}
      </AppSettingsLoader>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/layouts/layout-switcher.js